import React from "react";
import "./index.css";
import Sidebar from "../../../../components/Sidebar";
import TableHeader from "../../../../components/TableHeader/index";
import PageHeader from "../../../../components/PageHeader";
import Pagination from "../../../../components/Pagination";
import ModalDeleteGroupUser from "./modalDeleteGroupUser";
import ModalCreateGroupUser from "./modalCreateGroupUser";
import ModalEditGroupUser from "./modalEditGroupUser";
import {checkPermission} from "../../../../utils/common";
import  PublicSecureAuthorization from  "../../../../services/system/secure-authorization/secure-authorization-controller";
import {toast} from "react-toastify";
import LinkPlus from "../../../../components/Link/LinkPlus";
import {getSchoolId} from "../../../../utils/authority";

class GroupUserManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isSchoolId: getSchoolId() >=0,
            searchText: "",
            listData: [],

            pageNumber: 0,
            pageSize: 10,
            page: 0,
            code: "",
            status: "",
            sort: 'id',
            totalItem: 0,
            header: [
                {
                    id: "123",
                    name: "STT",
                    style: {textAlign: "center"},
                    sort: false,
                    isHide: false
                },
                {
                    id: "name",
                    name: "Tên nhóm",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "des",
                    name: "Mô tả",
                    style: {textAlign: "center"},
                    sort: false,
                    isHide: false
                },
                {
                    id: "permission",
                    name: "Phân quyền",
                    style: {textAlign: "center"},
                    sort: false,
                    isHide: !checkPermission("GROUP_USER_DETAIL")
                },
                {
                    id: "",
                    name: "Thao tác",
                    style: {minWidth: 120, textAlign: "center"},
                    sort: false,
                    isHide: !checkPermission("GROUP_USER_EDIT") || !checkPermission("GROUP_USER_DELETE")
                }
            ]
        };
    }

    componentDidMount() {
        this.setState({showLoading: true},
            () => this.getListGroupUser()
        )
    }

    getListGroupUser() {
        PublicSecureAuthorization.getListRoles(res => {
            if (res.success) {
                this.setState(
                    {
                        listData: res.data.content,
                        totalItem: res.data.totalElements,
                        totalPage: Math.round(res.data.totalElements / this.state.pageSize),
                        showLoading: false
                    }
                );
            } else {
            }
        });
    }

    onhandleSearch = () => {
        let payload = {
            pageNumber: 0,
            pageSize: 100,
            role: this.state.searchText,
            "sort": "created_at desc"
        }
        PublicSecureAuthorization.searchRole(payload, res => {
            if (res.success) {
                this.setState(
                    {
                        listData: res.data.content,
                        totalItem: res.data.totalElements,
                        totalPage: Math.round(res.data.totalElements / this.state.pageSize),
                        showLoading: false
                    }
                );
            } else {
                toast.error("Có lỗi xảy ra!", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 3000
                });
            }
        })
    };

    onHandleClearText() {
        this.setState(
            {
                "sort": "created_at desc",
                searchText: "",
            },
            () => this.onhandleSearch()
        );
    }

    handleChangePage = page => {
        this.setState(
            {
                pageNumber: page
            },
            () => {
                this.getListGroupUser();
            }
        );
    };

    // ------------------------------------------------------------------------------------------------------

    render() {
        let {listData, header} = this.state;
        return (
            <div>
                <div className="container">
                    <div className="row">
                        <Sidebar activeClass="group-user-management" parentClass="system-school-management"/>
                        <div className="col-md-10 tab-content with-loading">
                            {this.state.showLoading &&
                            <div className="content-loading col-12 ml-3 align-items-center"
                                 style={{display: 'block'}}>
                                <div className="spinner-grow text-info"/>
                            </div>
                            }
                            <div className="card col-12">
                                <div className="pt-3 mb-2">
                                    <PageHeader routerEnable={true} title="Quản lý nhóm người dùng"/>
                                    <form className="mt-4 kt-form kt-form--fit kt-margin-b-20">
                                        {checkPermission("GROUP_USER_SEARCH") &&
                                            <div className="row">
                                                <div className="col-8 col-md-5 p-0 pr-md-3 d-flex">
                                                    <label className="col-6 col-md-3 label-item">Tên nhóm</label>
                                                    <input
                                                        placeholder="GiaoVien"
                                                        name="Code"
                                                        type="text"
                                                        className="form-control shadow-none font-14"
                                                        style={{width: "100%", height: 35, padding: 8}}
                                                        value={this.state.searchText}
                                                        maxLength={50}
                                                        onKeyPress={(e) => {
                                                            if (e.key === 'Enter') {
                                                                this.onhandleSearch()
                                                            }
                                                        }}
                                                        onChange={val =>
                                                            this.setState({searchText: val.target.value.trim()})
                                                        }
                                                    />
                                                </div>
                                                <div className="col-4 col-md-4 p-0 pr-md-3 d-flex">
                                                    <button
                                                        style={{height: 35, marginLeft: 8}}
                                                        type="button"
                                                        className="border-1-s background-btn type-button-fix btn btn-primary btn-sm"
                                                        onClick={() => this.onhandleSearch()}
                                                    >
                                                        Tìm kiếm
                                                    </button>
                                                </div>
                                            </div>
                                        }
                                        {this.state.isSchoolId && checkPermission("GROUP_USER_ADD") &&
                                            <div>
                                                <div className="col-xs-12 col-sm-12 col-md-12 p-0 pr-md-3 d-flex"
                                                     style={{
                                                         alignItems: "center",
                                                         justifyContent: "right"
                                                     }}>
                                                    <button
                                                        style={{height: 35, marginRight: 12, marginTop: 8}}
                                                        type="button"
                                                        onClick={() => this.setState({showModalCreate: true})}
                                                        className="border-1-s background-btn type-button-fix btn btn-primary btn-sm"
                                                    >
                                                        Thêm mới
                                                    </button>
                                                </div>
                                            </div>
                                        }
                                    </form>
                                </div>
                                <div className="p-0 mb-3">
                                    <div className="table-wrapper">
                                        <table
                                            className="table table-striped table-data table-responsive table-bordered">
                                            <table className="table">
                                                <thead>
                                                <TableHeader
                                                    header={header}
                                                />
                                                </thead>
                                                {!this.state.listData ||
                                                this.state.listData.length == 0 ? (
                                                    <tbody>
                                                    <tr>
                                                        <td colSpan={12}>
                                                            <div className="text-center">
                                                                Không có dữ liệu
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                ) : (
                                                    <tbody>
                                                    {listData &&
                                                    listData.length > 0 &&
                                                    listData?.map((row, index) => (
                                                        <tr style={{height: 50}}>
                                                            <td style={{textAlign: "center"}} scope="row">
                                                                {" "}
                                                                {this.state.pageNumber * this.state.pageSize +
                                                                index +
                                                                1}
                                                            </td>
                                                            <td style={{textAlign: "left"}} scope="row">
                                                                {row.role}
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                {row.description}
                                                            </td>
                                                            {checkPermission("GROUP_USER_DETAIL") && <td style={{textAlign: "center"}}>
                                                                {this.state.isSchoolId && <LinkPlus
                                                                    to={'/ad-sas-school/phan-quyen-nhom-nguoi-dung?nhom=' + row.role}
                                                                >
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-action p-2"
                                                                        title='Phân quyền'
                                                                        style={{cursor: 'pointer'}}
                                                                    >
                                                                        <i className="fas fa-users"/>
                                                                    </button>
                                                                </LinkPlus>
                                                                }
                                                            </td>}
                                                            {(checkPermission("GROUP_USER_EDIT") || checkPermission("GROUP_USER_DELETE")) && <td style={{textAlign: "center"}}>
                                                                {this.state.isSchoolId && checkPermission("GROUP_USER_EDIT") &&
                                                                    <button className="btn btn-action p-2"
                                                                            title='Sửa'
                                                                            style={{cursor: 'pointer'}}
                                                                            onClick={() => {
                                                                                this.setState({itemSelected: row.id, role: row.role, des: row.description, showModalEdit: true})
                                                                            }}
                                                                    >
                                                                        <i className="ti-pencil-alt"/>
                                                                    </button>
                                                                }
                                                                {this.state.isSchoolId && checkPermission("GROUP_USER_DELETE") &&
                                                                    <button className="btn btn-action p-2"
                                                                            title='Xóa'
                                                                            style={{cursor: 'pointer'}}
                                                                            onClick={() => {
                                                                                this.setState({itemSelected: row.id, showModalDelete: true, name: row.role})
                                                                            }}
                                                                    >
                                                                        <i className="ti-trash"/>
                                                                    </button>
                                                                }
                                                            </td>}
                                                        </tr>
                                                    ))}
                                                    </tbody>
                                                )}
                                            </table>
                                        </table>
                                    </div>
                                    <div className="pagination-right">
                                        <Pagination
                                            activePage={this.state.pageNumber}
                                            itemsCountPerPage={this.state.pageSize}
                                            totalItemsCount={this.state.totalItem}
                                            changeHandler={page => this.handleChangePage(page)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ModalDeleteGroupUser
                    show={this.state.showModalDelete}
                    onHide={() => this.setState({showModalDelete: false})}
                    onRefresh={() => this.getListGroupUser()}
                    id={this.state.itemSelected}
                    role={this.state.name}
                />

                <ModalCreateGroupUser
                    show={this.state.showModalCreate}
                    onHide={() => this.setState({showModalCreate: false})}
                    onRefresh={() => this.getListGroupUser()}
                    id={this.state.itemSelected}
                />

                <ModalEditGroupUser
                    show={this.state.showModalEdit}
                    onHide={() => this.setState({showModalEdit: false})}
                    onRefresh={() => this.getListGroupUser()}
                    id={this.state.itemSelected}
                    role={this.state.role}
                    des={this.state.des}
                />
            </div>
        );
    }
}

export default GroupUserManagement;
